class FeedbackTabsAndForm {
	constructor (el) {

		// bootstrap tabs-navigation, specifically for feedback tabs

		var $feedbackContainer = jQuery('.feedback__inner');
		if($feedbackContainer.length){
			jQuery('#feedback-tabs a').on('click', function(e){
				e.preventDefault();
				jQuery(this).tab('show');

				if(jQuery(this).attr('id') == 'feedback-ja-tab'){
					setTimeout(() => {
						console.log('Feedback form submitted for helpful content; "yes".');
						jQuery('#feedback-ja-form').submit();
					}, 500);
				}
			});

			var textareaValueLength = 0,
				$feedbackNejForm = $feedbackContainer.find('#feedback-nej-form'),
				$feedbackComment = $feedbackNejForm.find('#feedback-comment'),
				maximumChars = $feedbackComment.data('maximum-chars'),
				$countCon = $feedbackComment.siblings('.feedback-count'),
				$actualCharsCountCon = $countCon.find('.actual-count'),
				$feedbackSubmit = $feedbackNejForm.find('.btn-primary'),
				$feedbackMessage = $feedbackNejForm.find('.feedback-message'),
				$feedbackSuccess = $feedbackNejForm.find('.feedback-success');

			$feedbackComment
				.on('keypress', function(e){
					textareaValueLength = jQuery(this).val().length;
					if(textareaValueLength >= maximumChars){
						e.preventDefault();
					}
				})
				.on('keyup', function(e){
					textareaValueLength = jQuery(this).val().length;
					$actualCharsCountCon.text(textareaValueLength);
				});

			$feedbackSubmit.on('click', function(e){
				e.preventDefault();
				if($feedbackComment.val().length === 0){
					$feedbackMessage.addClass('is-shown');
				} else {
					$feedbackMessage.removeClass('is-shown');
					$feedbackSuccess.addClass('is-shown');
					$feedbackComment.attr('disabled', 'disabled');
					$feedbackSubmit.attr('disabled', 'disabled');

					console.log('Feedback form submitted for helpful content; "no".');
					// form submit and show thank you...
				}
			});
		}
	}
}

export default FeedbackTabsAndForm
